export const rawPaymentList = [
  {
    'bePaymentTypeId': 1234567,
    'paymentTypeId': 0,
    'paymentTypeDescription': 'Visa',
    'paymentName': 'Aristide Cavaille-Coll',
    'paymentNumber': 'XXXXXXXXXXX0123',
    'expMonth': '04',
    // 1 year before the present
    'expYear': (new Date().getFullYear() - 2001).toString(),
    'paymentPostalCode': '21230',
    'defaultPayment': false,
    'city': 'Baltimore',
    'address1': '1234 S Charles Street',
    'address2': null,
    'region': 'MD',
    'district': null,
    'countryCode': 'US',
    'ccToken': 'tb9G9klAtpsjmSVmfIBSs3U3f-0709'
  },
  {
    'bePaymentTypeId': 2345678,
    'paymentTypeId': 0,
    'paymentTypeDescription': 'Visa',
    'paymentName': 'Cesar Franck',
    'paymentNumber': 'XXXXXXXXXXX1111',
    'expMonth': '11',
    'expYear': (new Date().getFullYear() - 1998).toString(),
    'paymentPostalCode': '21230',
    'defaultPayment': false,
    'city': 'Baltimore',
    'address1': '1234 St. Paul Street',
    'address2': null,
    'region': 'MD',
    'district': null,
    'countryCode': 'US',
    'ccToken': 'tb9G9klAtpsjmSVmfIBSs3U3f-0709'
  },
  {
    'bePaymentTypeId': 3456789,
    'paymentTypeId': 0,
    'paymentTypeDescription': 'Visa',
    'paymentName': 'Johann Sebastian Bach',
    'paymentNumber': 'XXXXXXXXXXX9876',
    'expMonth': '05',
    'expYear': (new Date().getFullYear() - 1999).toString(),
    'paymentPostalCode': '21230',
    'defaultPayment': false,
    'city': 'Baltimore',
    'address1': '1234 N Calvert Street',
    'address2': null,
    'region': 'MD',
    'district': null,
    'countryCode': 'US',
    'ccToken': 'tb9G9klAtpsjmSVmfIBSs3U3f-0709'
  }
];

